module.exports = __webpack_public_path__ + "img/icon.0a065b59.jpg";